export { CategoriesContainer as default } from './categories-container';
